export default __webpack_public_path__ + "imgs/theEnd.e4d2351.jpeg";